import { FC, MouseEvent, RefObject, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

import clsx from "clsx";
import { IObjectMaterial } from "../../interface";
import { ITexture } from "../../interface/ITexture";
import { TextureMenu } from "../texture-menu";
import { ToolbarButton } from "../toolbar-button";
import "./style.scss";

type TexturePickerProps = {
    index: number;
    className?: string;
    isMobile?: boolean;
    label?: string;
    panelRef?: RefObject<HTMLDivElement | null>;
    material: IObjectMaterial;
    textures: Array<ITexture>;
    onItemClick?: (material: IObjectMaterial, e?: MouseEvent) => void;
};

export const TexturePicker: FC<TexturePickerProps> = ({
    className,
    textures,
    label,
    isMobile = false,
    material,
    panelRef,
    index,
    onItemClick,
}) => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<ITexture | null>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        material.texture = textures[index];
        setSelected(textures[index]);

        if (onItemClick) {
            onItemClick(material);
        }
    }, [material]);

    return (
        <>
            {selected && (
                <ToolbarButton
                    ref={buttonRef}
                    isMobile={isMobile}
                    material={material}
                    active={open}
                    text={label}
                    selected={
                        selected.displayName && selected.displayName !== "None"
                            ? selected.displayName
                            : label
                    }
                    className={clsx("menu-button", className)}
                    image={selected.thumbnail}
                    onClick={(e: MouseEvent) => {
                        setOpen(!open);
                    }}
                />
            )}
            {open &&
                createPortal(
                    <TextureMenu
                        isMobile={isMobile}
                        open={open}
                        panelRef={panelRef}
                        selected={selected}
                        items={textures}
                        onItemClick={(value, e) => {
                            if (onItemClick) {
                                material.texture = value;
                                onItemClick(material, e);
                            }
                            setSelected(value);
                            setOpen(!open);
                        }}
                        onHide={() => {
                            setOpen(false);
                        }}
                        targetRef={buttonRef}
                    />,
                    document.body,
                )}
        </>
    );
};
